import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dropzone"];

  dragStart(event) {
    event.dataTransfer.dropEffect = "copy";
    event.dataTransfer.setDragImage(event.currentTarget, 0, 0);
    this.draggedElement = event.currentTarget;
  }

  dragEnd() {
    this.draggedElement = null;
  }

  dragOver(event) {
    event.preventDefault();
    this.dropzoneTarget.classList.add("dragging");
  }

  dragLeave(event) {
    event.preventDefault();
    this.dropzoneTarget.classList.remove("dragging");
  }

  drop(event) {
    if (this.draggedElement) {
      event.preventDefault();
      this.dropzoneTarget.classList.remove("dragging");

      $("a", this.draggedElement).get(0).click();
    }
  }
}
